import React from "react";
import { ClutterGrids } from "./ClutterGrids";
import { Colors } from "../../../../utils/colors";
import { ClutterGraphBoundaryDistribution } from "../ClutterGraphBoundaryDistribution";

type props = {};

export const ClutterGridPlotGraph: React.FC<props> = () => {
  return (
    <div style={styles.container}>
      <div style={styles.thinBar} />
      <div style={styles.graphBoundary}>
        <div style={styles.gridContainer}>
          <ClutterGrids />
        </div>
        <div style={styles.boundaryContainerStyle}>
          <ClutterGraphBoundaryDistribution />
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    position: "relative",
  },
  thinBar: {
    height: 5,
    width: "100%",
    backgroundColor: Colors.darkBrown,
    borderRadius: 3,
  },
  gridContainer: {
    height: "100%",
    width: "100%",
  },
  boundaryContainerStyle: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  graphBoundary: {
    height: 272,
    width: "97%",
    borderColor: Colors.darkBrown,
    borderWidth: 1,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderStyle: "solid",
    position: "relative",
    overflow: "hidden",
  },
};
